<div class="container full-height">
  <div class="row h-100">
  <div class="col align-items-center d-flex justify-content-md-center ">
    <div class="card border-0">
      <article class="card-body">
        <h4 class="card-title text-center mb-0 mt-1"><img alt="logo" class="center-block" src="assets/logo.gif"></h4>
        <hr>
        <ngb-alert *ngIf="error" [type]="'danger'" (close)="error=''">{{error}}</ngb-alert>
        <form (ngSubmit)="onSubmit()" #loginForm="ngForm">

          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text"> <fa-icon [icon]="faUser"></fa-icon> </span>
              </div>
              <input id="loginId" name="loginId" class="form-control" placeholder="Login ID"
                     required [(ngModel)]="loginUser.username" #loginId="ngModel">
            </div> <!-- input-group.// -->
          </div> <!-- form-group// -->

          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text"> <fa-icon [icon]="faLock"></fa-icon> </span>
              </div>
              <input [type]="hidePassword ? 'password' : 'text'" name="password" id="password" class="form-control" placeholder="Password"
                     autocomplete="current-password" required [(ngModel)]="loginUser.password" #password="ngModel">
              <div class="input-group-append">
                <span class="input-group-text" (click)="toggleHidePassword()">
                  <fa-icon *ngIf="!hidePassword" [icon]="faEyeSlash"></fa-icon>
                  <fa-icon *ngIf="hidePassword" [icon]="faEye"></fa-icon>
                </span>
              </div>
            </div> <!-- input-group// -->
          </div> <!-- form-group// -->

          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-block" [disabled]="!loginForm.valid"> Login  </button>
          </div> <!-- form-group// -->

          <p class="text-center"><a [routerLink]="['/forgot']" class="btn">Forgot password?</a></p>
        </form>
      </article>
    </div> <!-- card.// -->
  </div>
  </div>
</div>
